
import Vue from 'vue';
import { mapState } from 'vuex';
import { RUNNITS_ACCESS_LEVEL } from '@run-diffusion/shared';
import RunnitImage from './RunnitImage.vue';
import { RunnitsCRUDMixin, TeamUserMixin } from '@/mixins';
import ManageRunnitMenuBtn from './ManageRunnitMenuBtn.vue';

export default Vue.extend({
	name: 'RunnitTitleBar',
	props: {
		isTemplate: {
			type: Boolean,
			default: false,
		},
	},
	mixins: [
		RunnitsCRUDMixin,
		TeamUserMixin,
	],
	computed: {
		...mapState([
			'runnitState',
		]),
		computedTitleTruncateLength () {
			let length = 15;

			if (this.$vuetify.breakpoint.lgAndUp) {
				length = 30;
			}

			return length;
		},
		createNewMode () {
			return !!this.runnitState.runnitDraft;
		},
		canEditRunnit (): boolean {
			return !!(
				this.createNewMode ||
				(
					this.runnitState?.runnit &&
					(
						this.hasManageAllGenerationsPermission ||
						(
							this.runnitState.runnit.userId === this.user.id ||
							(
								[RUNNITS_ACCESS_LEVEL.SHARED, RUNNITS_ACCESS_LEVEL.RESTRICTED].includes(this.runnitState.runnit.accessLevel) &&
								this.hasShareRunnitAssetsPermission
							)
						)
					)
				)
			);
		},
	},
	components: {
		RunnitImage,
		ManageRunnitMenuBtn,
	},
});
